import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FooterComponent } from './components/footer/footer.component';
import { NavigationEnd, Router, RouterOutlet, Event } from '@angular/router';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ClickOutsideDirective } from 'src/app/shared/directives/click-outside.directive';
import { NgClass, NgIf } from '@angular/common';
import { CustomBackdropComponent } from './components/custom-backdrop/custom-backdrop.component';
import { MenuService } from './services/menu.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SidebarMenuComponent } from './components/sidebar/sidebar-menu/sidebar-menu.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: true,
  imports: [
    CustomBackdropComponent,
    SidebarComponent,
    NavbarComponent,
    RouterOutlet,
    FooterComponent,
    ClickOutsideDirective,
    NgClass,
    NgIf,
    AngularSvgIconModule,
    SidebarMenuComponent,
    MatIconModule,
  ],
})
export class LayoutComponent implements OnInit {
  @ViewChild('sidebar') sidebar: ElementRef | undefined;

  showBackdrop = false;

  constructor(private router: Router, public menuService: MenuService) {}

  ngOnInit(): void {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.sidebar?.nativeElement.classList.add('-translate-x-full');
        this.showBackdrop = false;
      }
    });
  }

  toggleSidebar() {
    this.sidebar?.nativeElement.classList.toggle('-translate-x-full');
    this._onChangeOpenSidebar();
  }

  onClickedOutside() {
    if (!this.sidebar?.nativeElement.classList.contains('-translate-x-full')) {
      this.sidebar?.nativeElement.classList.add('-translate-x-full');
      this._onChangeOpenSidebar();
    }
  }

  onClickedOpenSidebarDrawer() {
    this.sidebar?.nativeElement.classList.toggle('-translate-x-full');
  }

  private _onChangeOpenSidebar() {
    if (!this.sidebar?.nativeElement.classList.contains('-translate-x-full')) {
      this.showBackdrop = true;
    } else {
      this.showBackdrop = false;
    }
  }
}
